export default __webpack_public_path__ + "static/media/Gatsbyjs.48e68400.png";